import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './vuetify'
import Vuelidate from 'vuelidate'
import VueClipboard from 'vue-clipboard2'
import VModal from 'vue-js-modal'


Vue.config.productionTip = false

window.axios = require('axios')
// window.axios.defaults.baseURL = 'https://g78pg5d94q.dev-eblitz.com';
window.axios.defaults.baseURL = process.env.VUE_APP_apiUrl;

Vue.use(VueClipboard)
Vue.use(Vuelidate)
Vue.use(VModal)

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
